import { createSelector } from 'redux-starter-kit';

const capacityForLossSelector = (state: any) => state.capacityForLoss;

export const capacityForLossSelectors = {
  getQuestions: createSelector(
    capacityForLossSelector,
    subState => subState.questions
  ),
  getResponses: createSelector(
    capacityForLossSelector,
    subState => subState.responses
  ),
  getConfig: createSelector(
    capacityForLossSelector,
    subState => subState.config
  ),
  hasCapacityForLossEnabled: createSelector(capacityForLossSelector, subState =>
    subState.config.includes(1)
  ),
  hasRiskRequirementCapacityEnabled: createSelector(
    capacityForLossSelector,
    subState => subState.config.includes(2)
  )
};
